module.exports = __webpack_public_path__ + "img/truth-gpt-purple-hero-banner.2f2942b6.webp";